//import 'bootstrap/dist/css/bootstrap.min.css';

// Bootstrap CSS

// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'bootstrap';
import '@vuepic/vue-datepicker/dist/main.css';

import { createApp, markRaw } from 'vue';
import {
  faArrowTurnDown,
  faCircleArrowLeft,
  faCircleArrowRight,
  faFilter,
  faFloppyDisk,
  faHouse,
  faMagnifyingGlass,
  faPenToSquare,
  faSquareMinus,
  faSquarePlus,
  faTableCells,
  faTrash,
  faUser,
  faUserSecret,
} from '@fortawesome/free-solid-svg-icons';

import App from './App.vue';
import CandyTheme from 'fusioncharts/themes/fusioncharts.theme.candy';
import Charts from 'fusioncharts/fusioncharts.charts';
import Datepicker from '@vuepic/vue-datepicker';
import { FCComponent } from 'vue-fusioncharts';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import FusionCharts from 'fusioncharts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import OceanTheme from 'fusioncharts/themes/fusioncharts.theme.ocean';
import VueFusionCharts from 'vue-fusioncharts';
import { createPinia } from 'pinia';
import { faFileZipper } from '@fortawesome/free-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import router from './router.js';

// Bootstrap JS

Charts(FusionCharts);

/* add icons to the library */
library.add(
  faUserSecret,
  faUser,
  faHouse,
  faCircleArrowLeft,
  faCircleArrowRight,
  faTableCells,
  faTrash,
  faPenToSquare,
  faArrowTurnDown,
  faFloppyDisk,
  faMagnifyingGlass,
  faUserSecret,
  faSquarePlus,
  faSquareMinus,
  faFileZipper,
  faFilter
);

const pinia = createPinia();

const app = createApp(App);

app.use(
  VueFusionCharts,
  FusionCharts,
  Charts,
  FusionTheme,
  OceanTheme,
  CandyTheme
);
//app.use(FusionCharts, Charts);

pinia.use(({ store }) => {
  store.$router = markRaw(router);
});

app.use(router);
app.use(pinia);
//app.use(store);
//app.use(i18n);
//app.use(Bootstrap);

app.component('font-awesome-icon', FontAwesomeIcon);
app.component('fusioncharts', FCComponent);
app.component('Datepicker', Datepicker);

// app.component('Button', Button);
// app.component('Toast', Toast);

app.mount('#app');
